module.exports = __webpack_public_path__ + "fb55790c60a6920517d146dfe1d954fa.png";